<template>
  <div
    class="group-manage conmon-top aud-group-man-append"
    style="height: 100%;"
  >
    <el-container style="overflow-x: hidden;">
      <!--右侧列表-->
      <div
        class="table-first-style"
        style="padding: 0;width: 100%; overflow-x: hidden;"
      >
        <div
          class="base-input ovf-hd"
          style="margin-bottom: 10px; overflow-x: hidden;"
        >
          <el-row class="search-title">
            <el-col
              :span="4"
              class="table-title"
            >
              <i
                class="el-icon-search"
                style="font-weight: bold"
              ></i>
              <span class="order-list-search-span">添加客户</span>
            </el-col>
          </el-row>
          <!-- 查询区域 -->
          <!--高级查询-->
          <el-row
            class="search-content"
            style="min-height:210px;height:auto;line-height: 0"
          >
            <div
              style="text-align: left;padding: 20px 0"
              class="hei-ser"
            >
              <el-col style="text-align: left;padding-bottom: 10px;margin-top: 10px;">
                <span class="aud-query-add-sapn"><i style="color: red;">* </i>
                  <span>群组条件</span>:
                </span>
                <higher-search-audiences
                  class="common-search-formtype aud-manage-higher-search group-item-style"
                  :allRelationship="allRelationship"
                  :forSonTerms="forSonTerms"
                  @change="getAllTerms"
                  :isAnalyse="isAnalyse"
                ></higher-search-audiences>
              </el-col>
              <el-button
                type="primary"
                :disabled="isDisabled"
                :class="isDisabled ? 'disabled' : 'add-btn'"
                class="add-btn"
                style="margin-right: 32px"
                @click="saveQuery"
              >保存</el-button>
              <el-button
                type="primary"
                class="add-btn"
                style="margin-right: 10px;margin-bottom: 20px;"
                @click="preView"
              >预览</el-button>
            </div>
          </el-row>
        </div>
        <el-row
          class="search-title common-table-top"
          style="padding-right:0"
        >
          <el-col
            :span="6"
            class="table-title name-wrapper"
          >
            <i
              class="el-icon-document"
              style="font-weight: bold;"
            ></i>
            <span v-text="useName"></span>
          </el-col>
        </el-row>
        <!--客户列表-->
        <el-table
          class="audiences-table-content"
          v-loading="loading"
          :data="tableData"
          border
        >
          <el-table-column
            :sortable="data.isSort"
            min-width="160"
            :label="data.label"
            v-for="data in headerList"
            :key="data.identity"
            :prop="data.identity"
          >
            <template slot-scope="scope">
              <img
                v-if="data.identity == 'avatar'"
                style="width: 32px; height: 32px; display: block; border-radius: 50%; text-align: left; float: left; margin-right: 10px;"
                :src="scope.row[data.identity] | showImgUrl"
              />
              <div
                v-else
                :class="isSafari ? 'aud-show-divs' : 'aud-show-div'"
              >
                <span :title="scope.row[data.identity]">{{ scope.row[data.identity] }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="table-foot"
          style="text-align: right"
        >
          <span style="font-weight: 400;color: #606266;font-size: 13px;line-height: 40px;">共 {{ totalCount }} 条</span>
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="prev, pager, next"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import { getGroupTypeList, deleteGroupType, getGroupList, editGroupType, deleteGroup, getCustomerList } from '@/api/customer.js'
import { getCusTypes, addAudGroupDetail, getAudGroupGroupList, addAudGroup, getAudiencesList, getAudListShowSix, getCusAttrList, getAudGroupDetail, audEditGroup } from '@/api/set.js'
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
export default {
  name: 'audGroupManageAdd',
  data() {
    return {
      isAnalyse: false,
      isDis: false,
      rowList: [],
      source: [],
      stages: [],
      isSafari: false,
      allRelationship: 'and',
      headerList: [],
      useName: '',
      group_type: 1,
      loading: false,
      group_id: '',
      queryGroups: [],
      tableData: [],
      customerData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      search: {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '真实姓名',
                relationship: '',
                // relationOptions: [
                //   {
                //     value: 'equal',
                //     label: '等于'
                //   }, {
                //     value: 'not_equal',
                //     label: '不等于'
                //   }, {
                //     value: 'contain',
                //     label: '包含'
                //   }, {
                //     value: 'empty',
                //     label: '为空'
                //   },
                //   {
                //     value: 'not_empty',
                //     label: '不为空'
                //   }
                // ],
                value: null,
                option: null,
                startValue: '',
                endValue: '',
                // original_id: null,
                // eventAttributeList: [],
                // activitiesTwo: [],
                // templatesTwo: [],
                // wepageTwo: [],
                // eventAttrOptions: [
                //   {
                //     attributeContent: '',
                //     relationOptions: [],
                //     sources: [],
                //     eventAttrValueOptions: [],
                //     attributeRelation: '',
                //     attr_type: '',
                //     attrValTimeStart: '',
                //     attrValTimeEnd: '',
                //     attributeValueStart: '',
                //     attributeValueEnd: '',
                //     attributeValue: ''
                //   }
                // ],
                // optionOther: null,
                // qrcodeOptions: null,
                // templateOption: null,
                // qrcode: null,
                // offline_qrcode: null,
                // template_id: null,
                // leave_word: null,
                // public_reply_type_all: {
                //  reply_type: '不限',
                //  reply_content: ''
                // },
                // eventLimitTime: false,
                // eventLimitTimes: false,
                // eventLimitAttr: false,
                // eventTimeRelation: '',
                // eventDateStart: '',
                // eventDateEnd: '',
                // happenedTimes: '',
                // start_time: '',
                // end_time: '',
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      },
      groupNameTmp: '',
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      groupsType: {
        1: '动态群组',
        2: '静态群组'
      },
      createGroupType: 0,
      groupTypeIndex: 0,
      isDisabled: false,
      lastId: 0,
      allTerms: {},
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not_empty',
                  label: '不为空'
                }
              ],
              startValue: '',
              endValue: '',
              value: null,
              original_id: null,
              eventAttributeList: [],
              options: [],
              option: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', '']
            }
          ]
        }
      ],
      result: [],
      len: 0
    }
  },
  computed: {
    Newitems() {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function (item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences
  },
  methods: {
    // 请求初始来源
    loadSource() {
      getCustomerSources(1, 0, '').then((res) => {
        if (res.data.code == 200) {
          for (let one of res.data.result.list) {
            this.source[one.id] = one.name
          }
        }
      })
    },
    // 请求受众等级
    loadStage(modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      getCusStageList(modelId).then((res) => {
        if (res.data.code == 200) {
          res.data.result.unshift({
            id: 0,
            name: '未知'
          })
          for (let one of res.data.result) {
            this.stages[one.id] = one.name
          }
        }
      })
    },
    // 获取列表名字
    getAudiencesName(modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.params.id
          for (let item of this.modelData) {
            if (item.id == id) {
              this.useName = item.name + '列表'
              let arr = to.meta.routeArr
              arr[1].name = item.name + '添加客户'
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    // 切换群组类型
    toggleGroup(val) {
      console.log('01', val, this.group_type)
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              startValue: '',
              endValue: '',
              value: null,
              original_id: null,
              eventAttributeList: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
      this.load()
    },
    // 获取所属分组名字
    getAudGroupGroupLists() {
      let modelId = this.$route.params.id
      getAudGroupGroupList(modelId, '').then((res) => {
        if (res.data.code == 200) {
          res.data.result.unshift({
            id: 0,
            name: '全部'
          })
          this.queryGroups = res.data.result
        }
      })
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
      console.log('101', this.allTerms)
    },
    // 添加群组
    saveQuery() {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].selectedOptions[1] === '') {
              _g.toastMsg('error', '受众属性-具体属性不能为空')
              return
            }
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].startValue === '') {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].endValue === '' || item.terms[j].endValue === null) {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户画像标签是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'aud_portary') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户画像-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              for (let yi of item.terms[j].eventAttrOptions) {
                if (yi.attributeContent === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                  return
                }
                if (yi.attributeRelation === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                  return
                }
                if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                  if (yi.attributeValue === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                    return
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (!item.terms[j].eventDateStart || !item.terms[j].eventDateEnd) {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].startValue === 'undefined' || typeof item.terms[j].endValue === 'undefined' || item.terms[j].startValue === '' || item.terms[j].endValue === null || item.terms[j].endValue === '' || item.terms[j].startValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      let id = this.$route.query.id
      if (this.allTerms.termsGroup.length === 1) {
        console.log('sssss', this.allTerms)
        if (this.allTerms.termsGroup[0].terms[0].value == null && this.allTerms.allRelationship !== 'and') {
          _g.toastMsg('error', '请选择条件')
          return
        }
      }
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          // 删除无用属性
          // 判断是否属性attr
          if (one.selectedOptions[0] === 'attr') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
            delete one.eventTimeRelation
          }
          // 判断是否事件event
          if (one.selectedOptions[0] === 'event') {
            if (one.eventLimitTime === true) {
              one.eventDateStart = this.evalTime(one.eventDateStart)
              one.eventDateEnd = this.evalTime(one.eventDateEnd)
            }
            one.secAttr = one.selectedOptions[2]
            for (let o of one.eventAttrOptions) {
              delete o.sources
              delete o.relationOptions
              delete o.eventAttrValueOptions
            }
            delete one.startValue
            delete one.endValue
            delete one.relationship
          } else {
            one.secAttr = one.selectedOptions[1].split('@')[0]
          }
          // 判断是否群组group/标签aud_portary
          if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          delete one.eventLimitAttr
          delete one.eventLimitTime
          delete one.eventLimitTimes
          delete one.original_id
          delete one.option
          delete one.relationOptions
          delete one.eventAttributeList
          delete one.end_time
          delete one.start_time
          delete one.attr_label
          delete one.eventTimeRelation
        }
      }
      // 防止重复点击
      this.isDisabled = true
      let modelId = this.$route.params.id
      // 静态群组添加客户
      addAudGroupDetail(id, modelId, termsSend).then((res) => {
        if (res.data.code == 200) {
          this.isDisabled = false
          _g.toastMsg('success', res.data.message)
          this.$router.go(-1)
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 解析时间
    evalTime(time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let mon = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return year + '-' + mon + '-' + day + ' ' + h + ':' + m + ':' + s
    },
    // 预览
    preView() {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].selectedOptions[1] === '') {
              _g.toastMsg('error', '受众属性-具体属性不能为空')
              return
            }
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].startValue === '') {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].endValue === '' || item.terms[j].endValue === null) {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户画像标签是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'aud_portary') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户画像-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              for (let yi of item.terms[j].eventAttrOptions) {
                if (yi.attributeContent === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                  return
                }
                if (yi.attributeRelation === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                  return
                }
                if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                  if (yi.attributeValue === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                    return
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (!item.terms[j].eventDateStart || !item.terms[j].eventDateEnd) {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }

          // 判断受众身份是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'wechat_open_id') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }

          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].startValue === 'undefined' || typeof item.terms[j].endValue === 'undefined' || item.terms[j].startValue === '' || item.terms[j].endValue === null || item.terms[j].endValue === '' || item.terms[j].startValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          // 删除无用属性
          // 判断是否属性attr
          if (one.selectedOptions[0] === 'attr') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
            delete one.eventTimeRelation
          }
          // 判断是否事件event
          if (one.selectedOptions[0] === 'event') {
            if (one.eventLimitTime === true) {
              one.eventDateStart = this.evalTime(one.eventDateStart)
              one.eventDateEnd = this.evalTime(one.eventDateEnd)
            }
            one.secAttr = one.selectedOptions[2]
            if (one.eventLimitAttr === true) {
              for (let o of one.eventAttrOptions) {
                delete o.sources
                delete o.relationOptions
                delete o.eventAttrValueOptions
              }
            }
            delete one.startValue
            delete one.endValue
            delete one.relationship
          } else {
            one.secAttr = one.selectedOptions[1].split('@')[0]
          }
          // 判断是否群组group/标签aud_portary
          if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          // delete one.eventLimitAttr
          // delete one.eventLimitTime
          delete one.eventLimitTimes
          delete one.original_id
          delete one.option
          delete one.relationOptions
          delete one.eventAttributeList
          delete one.end_time
          delete one.start_time
          delete one.attr_label
          delete one.eventTimeRelation
        }
      }
      console.log('11122', termsSend)
      let modelId = this.$route.params.id
      this.search = termsSend
      this.loadSix(modelId)
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.loadSix()
    },
    handleCurrentChange(page) {
      this.page = page
      this.loadSix()
    },
    // 加载属性取前六个的列表（常用）
    loadSix(modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      getAudListShowSix(modelId).then((audListShowSixRes) => {
        if (audListShowSixRes.data.code == 200) {
          if (audListShowSixRes.data.result === '' || audListShowSixRes.data.result.fields === '') {
            getCusAttrList(modelId).then((res) => {
              if (res.data.code == 200) {
                let data = res.data.result
                let normal = []
                let notNormal = []
                for (let attr of data) {
                  if (attr.isNormal === 0) {
                    notNormal.push(attr)
                  } else {
                    normal.push(attr)
                  }
                }
                this.rowList = []
                if (normal.length <= 6) {
                  for (let i in normal) {
                    this.rowList.push({
                      identity: normal[i].identity,
                      type: normal[i].type,
                      sortRole: ''
                    })
                  }
                }
                if (normal.length > 6) {
                  this.rowList.push({
                    identity: normal[0].identity,
                    type: normal[0].type,
                    sortRole: ''
                  })
                  this.rowList.push({
                    identity: normal[1].identity,
                    type: normal[1].type,
                    sortRole: ''
                  })
                  this.rowList.push({
                    identity: normal[2].identity,
                    type: normal[2].type,
                    sortRole: ''
                  })
                  this.rowList.push({
                    identity: normal[3].identity,
                    type: normal[3].type,
                    sortRole: ''
                  })
                  this.rowList.push({
                    identity: normal[4].identity,
                    type: normal[4].type,
                    sortRole: ''
                  })
                  this.rowList.push({
                    identity: normal[5].identity,
                    type: normal[5].type,
                    sortRole: ''
                  })
                }
                this.load(modelId)
              }
            })
          } else {
            getCusAttrList(modelId).then((res) => {
              if (res.data.code == 200) {
                let data = res.data.result
                let normal = []
                let notNormal = []
                for (let attr of data) {
                  if (attr.isNormal === 0) {
                    notNormal.push(attr)
                  } else {
                    normal.push(attr)
                  }
                }
                this.rowList = JSON.parse(audListShowSixRes.data.result.fields)
                console.log('zhensjide', this.rowList)
                this.load(modelId)
              }
            })
          }
        }
      })
    },
    // 加载群组列表
    load() {
      this.loading = true
      let modelId = this.$route.params.id
      getAudiencesList(this.page, this.limit, this.search, modelId, this.rowList, null).then((res) => {
        if (res.data.code == 200) {
          this.headerList = res.data.result.header
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
          this.openLoading()
        }
      })
    },
    // 解析是动态群组编辑还是静态群组编辑
    editWhat() {
      let modelId = this.$route.params.id
      let id = this.$route.query.id
      let type = this.$route.query.type
      let rowList = []
      if (id) {
        this.isDis = true
        this.group_type = parseInt(type)
        // 静态群组
        getAudListShowSix(modelId).then((audListShowSixRes) => {
          if (audListShowSixRes.data.code == 200) {
            getCusAttrList(modelId).then((resp) => {
              if (resp.data.code == 200) {
                let data = resp.data.result
                let normal = []
                let notNormal = []
                for (let attr of data) {
                  if (attr.isNormal === 0) {
                    notNormal.push(attr)
                  } else {
                    normal.push(attr)
                  }
                }
                // 总的设置列属性
                let arr = JSON.parse(audListShowSixRes.data.result.fields)
                for (let a of arr) {
                  for (let item of normal) {
                    if (item.identity === a.identity) {
                      a.name = item.name
                    }
                  }
                }
                // 处理发给后台的表头
                for (let one of arr) {
                  if (one.isChecked === 1) {
                    rowList.push(one)
                  }
                }
                console.log('zhensjide', rowList)
                getAudGroupDetail(id, '', '', 1, 10, 1, rowList, modelId).then((res) => {
                  if (res.data.code == 200) {
                    this.group_id = res.data.result.groupId
                    this.newGroupName = res.data.result.name
                  }
                })
              }
            })
          }
        })
      }
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 判断是不是safari浏览器
      let userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
      if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
        vm.isSafari = true
      } else {
        vm.isSafari = false
      }
      vm.getAudGroupGroupLists(to.params.id, to)
      vm.getAudiencesName(to.params.id, to)
      // vm.loadSix(to.params.id)
      // vm.editWhat()
    })
  },
  beforeRouteUpdate(to, from, next) {
    // 判断是不是safari浏览器
    let userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
    if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
      this.isSafari = true
    } else {
      this.isSafari = false
    }
    this.getAudGroupGroupLists(to.params.id, to)
    this.getAudiencesName(to.params.id, to)
    // this.loadSix(to.params.id)
    // this.editWhat()
    next()
  },
  created() {
    // this.load()
  }
}
</script>

<style scoped>
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
@media only screen and (max-width: 1450px) {
  .text-align-right .fold-button-content {
    display: none;
  }
  .text-align-right .dropdown-btn-content {
    display: inline-block;
  }
}
.fold-button-content {
  float: right;
  display: inline-block;
}
.dropdown-btn-content {
  display: none;
}
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.disabled {
  background: #ccc !important;
}
.getIt {
  color: #ff5500 !important;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5; /*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc; /*滚动条的背景颜色*/
}
.el-dropdown-link {
  display: inline-block;
  background-color: #1890FF;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 92px;
  border-radius: 20px;
  color: #fff;
  outline: none;
  margin-right: 10px;
  cursor: pointer;
}
</style>
